import {
  Text,
  VStack,
} from '@chakra-ui/react';
import {
  useSmartBuyerSelfAssessment,
} from '@src/modules/performance/context/reports-api-hooks';
import IndicatorLegend from '@src/modules/performance/components/IndicatorLegend';
import { smartBuyerAssessmentsLegend, TRAFFIC_LIGHT_COLOURS } from '@src/modules/performance/shared/constants';
import { CircleIndicator } from '@src/modules/performance/components/indicators';
import ReportSection from './ReportSection';

const informationSource = {
  title: 'Procurement',
  content: [
    {
      title: 'Smart buyer self-assessment',
      description:
  <>
    <Text fontSize="inherit" mb={2}>
      The result of the RCA&rsquo;s smart buyer self-assessment undertaken by the TA and collated by Road Efficiency Group Te Ringa Maimoa.
      The assessment is based on the Smart Buyer Principles identified in the Road Maintenance Task Force Report.
    </Text>
    <Text fontSize="inherit" mb={2}>
      Result colour grading is as follows:
    </Text>
    <IndicatorLegend items={smartBuyerAssessmentsLegend} />
    <Text fontSize="inherit" mt={2}>
      <strong>Score Interpretation:</strong>
      <br />
      65 to 70: A Smart Buyer: Our organisation is a smart buyer. We help to minimise rate increases by maximising the value created for our community from being a smart buyer
      <br />
      55 to 64: Developing: Our organisation has embraced the principles of being a smart buyer but can still create further improved value for our communities
      <br />
      30 to 54: Limited: Our organisation currently has limited capability to maximise the value created from being a smart buyer
      <br />
      0 to 30: Basic: Our organisation is focused on tender process and compliance. We have not developed the capability to realise any of the value created for our community from being a smart buyer.
    </Text>
  </>,
      source: <Text fontSize="inherit" as="span">RCA self-assessment entered in Transport Insights</Text>,
    },
  ],
};

function ActivityManagementProcurement() {
  const { data: smartBuyerSelfAssessment, isLoading } = useSmartBuyerSelfAssessment();

  return (
    <ReportSection
      title="Procurement"
      informationSource={informationSource}
      isLoading={isLoading}
      lockYear={smartBuyerSelfAssessment?.lockYear}
    >
      <VStack
        spacing={4}
        mb={4}
      >
        <Text
          align="center"
          fontSize={12}
          fontWeight="bold"
          className="chart-title"
        >
          Smart buyer self-assessment
        </Text>
        <CircleIndicator
          size={90}
          colour={TRAFFIC_LIGHT_COLOURS[smartBuyerSelfAssessment?.colour]}
          value={null}
          isLoading={isLoading}
          padding={0}
        />
        <Text
          textAlign="center"
          fontSize="sm"
          whiteSpace="pre-line"
          color="gray.600"
        >
          {smartBuyerSelfAssessment?.value?.toFixed(0)}
          {' '}
          out of
          {' '}
          {smartBuyerSelfAssessment?.max?.toFixed(0)}
        </Text>
        <Text
          align="center"
          mt={2}
          fontSize="xs"
          className="report-source-text"
        >
          {smartBuyerSelfAssessment?.source}
          <br />
          Self-Assessment
        </Text>
      </VStack>
      <IndicatorLegend
        items={smartBuyerAssessmentsLegend}
      />
    </ReportSection>
  );
}

export default ActivityManagementProcurement;
